import NavBar from "../../Universal Components/NavBar/NavBar";
import ProblemsTable from "./ProblemTable/ProblemsTable";
import SearchBar from "./SearchBar/SearchBar";
import "./Problems.css"
import { useEffect, useState } from "react";
import { getSolvedProblems } from "../../Firebase/FireStore";


export default function Problems(){
    const [searchbar_content, set_searchbar_content] = useState("");
    const [difficulty_checkboxes, set_difficulty_checkboxes] = useState([]);
    const [topic_checkboxes, set_topic_checkboxes] = useState([]);
    const [modality_checkboxes, set_modality_checkboxes] = useState([]);
    const [page_number, set_page_number] = useState(0);
    const [num_problems, set_num_problems] = useState(0)
    const [solved_problems, set_solved_problems] = useState([])

    let buttons = Array.from(Array(Math.ceil(num_problems / 15)), (_,i) => {
    return (
        <button className="page-button" onClick={() => set_page_number(i)}>
            {i+1}
        </button>
    )});
    useEffect(() => {
        buttons = Array.from(Array(Math.ceil(num_problems / 15)), (_,i) => {(
            <button className="page-button" onClick={() => set_page_number(i)}>
                {i+1}
            </button>
        )});
    },[num_problems]);

    useEffect(() => {
        const fetchSolved = async () => {
            try {
                const solved = await getSolvedProblems();
                set_solved_problems(solved);
            } catch (err) {
                console.log("[ERROR] ", err);
            }
        };
        fetchSolved();
    },[])

    return (
        <>
            <NavBar/>
            <SearchBar 
                set_searchbar_content={set_searchbar_content}
                topic_checkboxes={topic_checkboxes} set_topic_checkboxes={set_topic_checkboxes}
                difficulty_checkboxes={difficulty_checkboxes} set_difficulty_checkboxes={set_difficulty_checkboxes}
                modality_checkboxes={modality_checkboxes} set_modality_checkboxes={set_modality_checkboxes}
            />

            
            <div className="problem-grid-container">
                <ProblemsTable
                    searchbar_content={searchbar_content}
                    topic_checkboxes={topic_checkboxes}
                    difficulty_checkboxes={difficulty_checkboxes}
                    modality_checkboxes={modality_checkboxes}
                    page_number={page_number}
                    set_num_problems={set_num_problems}
                    solved_problems={solved_problems}
                />
            </div>

                <div className="page-number">
                    {buttons}
                </div>

        </>
    );
}